module.exports = __webpack_public_path__ + "static/grid-cols-28a4511e483338c26b8dd68ceb2a411b.png";